<img class="no-permissions__blocked-view-img" [ngSrc]="content().imageSource" width="106" height="106" priority>

<p class="no-permissions__blocked-view-title">{{content().title}}</p>

<p [innerHtml]="(content().subtitle | safe)"></p>
